<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-message-check fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{request.request_type | capitalize}}</div>
            <div class="meta"><i class="far fa-calendar mr-2 fa-fw"></i>{{request.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</div>
            <div class="meta mt-1"><i class="far fa-paper-plane mr-2 fa-fw"></i>{{request.type | capitalize}}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="fas fa-check" v-if="request.fulfilled_at"></i><i class="fas fa-ban" v-if="!request.fulfilled_at"></i></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
<!--                <toolbar class="toolbar">-->
<!--                    <button class="icon-only" @click.stop=""><i class="far fa-pencil"></i></button>-->
<!--                </toolbar>-->

                <div class="data mt-1">
                    <data-row mini title="Request">{{request.request.replace(',',', ')}}</data-row>
                    <data-row mini title="Code">{{request.code}}</data-row>
                    <data-row mini title="Session">{{request.session}}</data-row>
                    <data-row mini title="Secret">{{request.secret}}</data-row>
                    <data-row mini title="Created">{{request.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="Settled">{{request.fulfilled_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="Completed">{{request.expires_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="ID">{{request.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'PlanRequestTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            request: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
